<template>
  <div></div>
</template>

<script>
export default {
  name: "SiteTitleManager",

  watch: {
    '$route.meta.pageTitle' () {
      this.initTitle()
    },

    getLocale () {
      this.initTitle()
    },
  },

  computed: {
    getLocale() {
      return this.$root.$i18n.locale
    }
  },

  mounted() {
    this.initTitle()
  },

  methods: {
    initTitle() {
      if(this.$t(`${this.$route.meta?.pageTitle}.localization_value.value`).indexOf('undefined') > -1 ||
          this.$t(`${this.$route.meta?.pageTitle}.localization_value.value`).indexOf('localization_value') > -1
      ){
        setTimeout(() => {
          if(this.$t(`${this.$route.meta?.pageTitle}.localization_value.value`).indexOf('localization_value') > -1){
            document.title = 'SkladUsa.com'
            return
          }
          document.title = this.$t(`${this.$route.meta?.pageTitle}.localization_value.value`) + ' | SkladUsa.com'
        }, 1000)
      } else {
        document.title = this.$t(`${this.$route.meta?.pageTitle}.localization_value.value`) + ' | SkladUsa.com'
      }

    },
  }

}
</script>

<style scoped>

</style>